// extracted by mini-css-extract-plugin
export default {"FullArea":"Styles_FullArea__a0+Zp","MenuArea":"Styles_MenuArea__XWypW"};